import { createReducer } from "@/redux/helpers/reducer";

import * as actions from "./user-ui-interactions.actions";

// `isLoaded` turns true with the first map, so a prompt that shows "until seen" never flashes
// before the user's map arrives.
const initialState = {
  interactions: {},
  isLoaded: false,
};

export default createReducer(initialState, {
  [actions.setInteractions]: (state, { value }) => ({ ...state, interactions: value, isLoaded: true }),
  [actions.reset]: () => ({ ...initialState }),
});
